import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import InfoView from '../views/InfoView.vue'
import AbstractView from '@/views/AbstractView.vue'
import SecondAdditionalInfoView from '@/views/SecondAdditionalInfoView.vue'
import PreviousConferenceView from '@/views/PreviousConferenceView.vue'
import PreviousConferenceGalleryView from '@/views/PreviousConferenceGalleryView.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
    },
    {
        path: '/info/:link',
        name: 'info',
        component: InfoView,
    },
    {
        path: '/abstract/:link',
        component: AbstractView,
    },
    {
        path: '/second-additional-info/:link',
        component: SecondAdditionalInfoView,
    },
    {
        path: '/previous-conferences/:year',
        name: 'previous-conference',
        component: PreviousConferenceView,
    },
    {
        path: '/previous-conferences/:year/galleries',
        name: 'previous-conference-galleries',
        component: PreviousConferenceGalleryView,
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition

        if (to.hash) {
            return new Promise(resolve => {
                const tryScroll = () => {
                    const el = document.querySelector(to.hash)
                    if (el) {
                        resolve({
                            el: to.hash,
                            behavior: 'smooth',
                        })
                    } else {
                        requestAnimationFrame(tryScroll)
                    }
                }
                // defer two frames to let layout settle
                requestAnimationFrame(() => requestAnimationFrame(tryScroll))
            })
        }

        return {top: 0}
    },
})

export default router
